(function () {
  function openSidebar(sidebar) {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar(sidebar) {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setGridView(grid, cols, view) {
    if (!grid) return;
    var maxCols = parseInt(grid.getAttribute('data-lpz-max-cols') || '3', 10);
    var nextCols = parseInt(cols, 10) || maxCols;
    if (view === 'list') {
      nextCols = 1;
      grid.classList.add('lpz-view-list');
    } else {
      grid.classList.remove('lpz-view-list');
    }
    grid.className = grid.className.replace(/lpz-cols-\d/g, '').replace(/\s+/g, ' ').trim();
    grid.classList.add('lpz-cols-' + nextCols);
    grid.style.setProperty('--lpz-grid-cols', String(nextCols));
  }

  function initAccordions(root) {
    if (!root) return;
    root.querySelectorAll('.lpz-shop-sidebar .sf__accordion-item').forEach(function (item) {
      var button = item.querySelector('.sf__accordion-button');
      var content = item.querySelector('.sf__accordion-content');
      if (!button || !content || button.dataset.lpzAccordionBound === 'true') return;
      button.dataset.lpzAccordionBound = 'true';

      if (item.classList.contains('open')) {
        content.style.opacity = '1';
        content.style.maxHeight = 'none';
      }

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        item.classList.toggle('open', !isOpen);
        if (!isOpen) {
          content.style.opacity = '1';
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.opacity = '0';
          content.style.maxHeight = '0';
        }
      });
    });
  }

  function convertSizeFilterMarkup(root) {
    if (!root) return;
    root.querySelectorAll('.lpz-shop-sidebar .sf__accordion-item.lpz-filter-size').forEach(function (item) {
      item.querySelectorAll('.facet-checkbox').forEach(function (label) {
        if (label.classList.contains('lpz-size-btn')) return;

        label.classList.remove('facet-checkbox');
        label.classList.add('lpz-size-btn');

        if (label.classList.contains('facet-checkbox--disabled')) {
          label.classList.add('lpz-size-btn--disabled');
          label.classList.remove('facet-checkbox--disabled');
        }

        label.querySelectorAll('svg').forEach(function (svg) {
          svg.remove();
        });

        var count = label.querySelector('.filter-products-count');
        if (count) count.remove();

        var filterLabel = label.querySelector('.filter-label');
        if (filterLabel) {
          filterLabel.classList.remove('filter-label');
          filterLabel.classList.add('lpz-size-btn__text');
        }

        var input = label.querySelector('input[type="checkbox"]');
        if (input) input.classList.add('visually-hidden');
      });
    });
  }

  function tagSizeFilters(root) {
    if (!root) return;
    root.querySelectorAll('.lpz-shop-sidebar .sf__accordion-item').forEach(function (item) {
      var label = item.querySelector('.sf__accordion-button');
      if (label && /size/i.test(label.textContent)) {
        item.classList.add('lpz-filter-size');
      }
    });
  }

  function observeSidebar(root) {
    var sidebar = root.querySelector('.lpz-shop-sidebar');
    if (!sidebar || sidebar.dataset.lpzSidebarObserved === 'true') return;
    sidebar.dataset.lpzSidebarObserved = 'true';

    var sidebarObserver = new MutationObserver(function () {
      tagSizeFilters(root);
      convertSizeFilterMarkup(root);
    });
    sidebarObserver.observe(sidebar, { childList: true, subtree: true });
  }

  function initSection(root) {
    if (!root) return;
    tagSizeFilters(root);
    convertSizeFilterMarkup(root);
    observeSidebar(root);
    initAccordions(root);
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches('.lpz-collection-shop .lpz-shop-sort-sel')) return;
    var opt = select.options[select.selectedIndex];
    var url = opt && opt.getAttribute('data-url');
    if (url) window.location.href = url;
  });

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('.lpz-collection-shop [data-lpz-sidebar-open]');
    if (openBtn) {
      var section = openBtn.closest('.lpz-collection-shop');
      openSidebar(section && section.querySelector('[data-lpz-sidebar]'));
      return;
    }

    if (event.target.closest('.lpz-collection-shop [data-lpz-sidebar-close], .lpz-collection-shop .sf__sidebar-close')) {
      var shopClose = event.target.closest('.lpz-collection-shop');
      closeSidebar(shopClose && shopClose.querySelector('[data-lpz-sidebar]'));
      return;
    }

    var colBtn = event.target.closest('.lpz-collection-shop [data-lpz-cols]');
    if (colBtn) {
      var shop = colBtn.closest('.lpz-collection-shop');
      var toggle = shop && shop.querySelector('[data-lpz-view-toggle]');
      var grid = shop && shop.querySelector('[data-lpz-grid]');
      if (!toggle || !grid) return;

      toggle.querySelectorAll('.lpz-shop-vbtn').forEach(function (btn) {
        btn.classList.remove('on');
      });
      colBtn.classList.add('on');

      var view = colBtn.getAttribute('data-lpz-view') || 'grid';
      var cols = colBtn.getAttribute('data-lpz-cols');
      setGridView(grid, cols, view);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.lpz-collection-shop').forEach(initSection);
  });

  if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
    window.MinimogEvents.subscribe('ON_PRODUCT_LIST_UPDATED', function () {
      document.querySelectorAll('.lpz-collection-shop').forEach(initSection);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lpz-collection-shop');
    if (section) initSection(section);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('.lpz-collection-shop')) {
          initSection(node);
        } else if (node.querySelector) {
          var shop = node.querySelector('.lpz-collection-shop');
          if (shop) initSection(shop);
          else if (node.matches && node.matches('.lpz-shop-sidebar, .sf__filter-wrapper, collection-filters-form')) {
            var section = node.closest('.lpz-collection-shop');
            if (section) initSection(section);
          }
        }
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    var main = document.getElementById('MainContent') || document.body;
    observer.observe(main, { childList: true, subtree: true });
  });
})();
